import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { isMobile } from 'react-device-detect';

import * as serviceWorker from './serviceWorker';

import App from './App';
import rootReducer from './reducers';
import './assets/css/App.css';

const store = createStore(rootReducer,  // for redux devtools extension
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const MatrixApp = props => (
    <Provider store={store}>
        <App setApp={props.app} />
    </Provider>
);

window.matrixApp = function(app) {
    ReactDOM.render(<MatrixApp app={app} />, document.getElementById('matrix_app'));
};

// disable the next line(s) BEFORE building and deploying
// ReactDOM.render(<MatrixApp app='EZ-Talk' />, document.getElementById('matrix_app'));     // app-1
// ReactDOM.render(<MatrixApp app='EZ-C' />, document.getElementById('matrix_app'));   // app-2
// ReactDOM.render(<MatrixApp app='EZ-Reading' />, document.getElementById('matrix_app'));     // app-3

if (isMobile) {     // this disables the right-clicks on mobile devices
    window.oncontextmenu = function(event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    };
}

serviceWorker.unregister();